import React, {Component} from "react";
import "./Designer.css";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import diploma1Img from "../store/designer/diplom1.jpg";
import diploma2Img from "../store/designer/diplom2.jpg";
import artistImg from '../store/designer/artist.jpg'
import bookImg from "../store/designer/book.jpg";
import protokolImg from "../store/designer/protokol.jpg";
import fashionDesignerImg from '../store/designer/fashion-designer.jpg';
import {withTranslation} from "react-i18next";
import i18next from "i18next";

class Designer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            photoIndex: 0,
            isOpen: false,
        };
    };

    images = [diploma1Img, diploma2Img, bookImg, protokolImg, artistImg, fashionDesignerImg];

    imgClickHandler = (e, index) => {
        e.preventDefault();
        this.setState({photoIndex: index, isOpen: true});
    };

    renderPart1 = () => {
        const {t} = this.props;
        const lang = i18next.languages[0];
        return (<p>
            <a href="#" onClick={e => this.imgClickHandler(e, 0)}>{t('designer.part1.1')}</a> -
            <a href="#" onClick={e => this.imgClickHandler(e, 5)}> {t('designer.part1.2')}</a>,
            <a href="#" onClick={e => this.imgClickHandler(e, 4)}> {t('designer.part1.3')}</a>, {t('designer.part1.4')},
            <a href="#" onClick={e => this.imgClickHandler(e, 1)}> {t('designer.part1.5')}</a>. {t('designer.part1.6')}.
            <a href="#" onClick={e => this.imgClickHandler(e, 3)}> {t('designer.part1.7')}</a>. {t('designer.part1.8')}.
        </p>);
        if (lang === 'ru') {
            return (<p>
                <a href="#" onClick={e => this.imgClickHandler(e, 0)}>{t('designer.part1.1')}</a> -
                <a href="#" onClick={e => this.imgClickHandler(e, 5)}> {t('designer.part1.2')}</a>,
                <a href="#" onClick={e => this.imgClickHandler(e, 4)}> {t('designer.part1.3')}</a>, {t('designer.part1.4')},
                <a href="#" onClick={e => this.imgClickHandler(e, 1)}> {t('designer.part1.5')}</a>. {t('designer.part1.6')}.
                <a href="#" onClick={e => this.imgClickHandler(e, 3)}> {t('designer.part1.7')}</a>. {t('designer.part1.8')}.
            </p>);
        } else return (
            <p>
                {t('designer.part1')}
            </p>
        )
    }

    renderPart2 = () => {
        const {t} = this.props;
        const lang = i18next.languages[0];
        return (<p>
            {t('designer.part2.1')}
            <a href="#" onClick={e => this.imgClickHandler(e, 2)}> "{t('designer.part2.2')}"</a>
        </p>);
        if (lang === 'ru') {
            return (<p>
                {t('designer.part2.1')}
                <a href="#" onClick={e => this.imgClickHandler(e, 2)}> "{t('designer.part2.2')}"</a>
            </p>);
        } else return (
            <p>
                {t('designer.part2')}
            </p>
        )
    }

    render() {
        const {isOpen, photoIndex} = this.state;
        const {t} = this.props;
        return (
            <div className="designer container">
                {isOpen && (
                    <Lightbox
                        mainSrc={this.images[photoIndex]}
                        onCloseRequest={() => this.setState({isOpen: false})}
                    />
                )}

                <div className="designer-img"></div>
                <div className="designer-desc">
                    {this.renderPart1()}
                    {this.renderPart2()}
                    <p>
                        {t('designer.part3')}
                    </p>
                    <p>
                        {t('designer.part4')}
                    </p>
                </div>
            </div>
        );
    };
};
export default withTranslation()(Designer)



// WEBPACK FOOTER //
// ./src/components/Designer.jsx